import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const ScreenProgressIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M10 8.57143V0H0V8.57143H4.375V9.28571H2.5V10H7.5V9.28571H5.625V8.57143H10ZM0.625 7.85714V0.714286H9.375V7.85714H0.625Z" />
            <path d="M6.58312 1.78564V2.20467H7.85531L5.35406 5.07084L3.72969 3.46177L1.25 6.11842L1.49438 6.4285L3.74406 4.02327L5.37562 5.64072L8.07812 2.5399V3.94784H8.4375V1.78564H6.58312Z" />
        </SvgIcon>
    );
};
